(() => {
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD'
  }).format(cents / 100);

  function numericPrice(text) {
    const n = Number(String(text || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
  }

  function enhanceQuantity() {
    document.querySelectorAll('input[name="quantity"]').forEach((input) => {
      if (input.dataset.lefunlandSubtotalReady) return;
      const form = input.closest('form[action*="/cart/add"]') || input.closest('product-form');
      if (!form) return;
      const scope = form.closest('product-information, .product-information, .product-details') || document;
      const priceNode = scope.querySelector('product-price .price:not(.compare-at-price), .price:not(.compare-at-price)');
      const unitCents = numericPrice(priceNode?.textContent);
      if (!unitCents) return;

      const subtotal = document.createElement('p');
      subtotal.className = 'lefunland-quantity-subtotal';
      subtotal.setAttribute('aria-live', 'polite');
      const note = document.createElement('p');
      note.className = 'lefunland-combine-note';
      note.textContent = 'Combine more standard sets for a larger play area.';
      const anchor = input.closest('quantity-selector, .quantity-selector, .quantity') || input.parentElement;
      anchor.insertAdjacentElement('afterend', note);
      note.insertAdjacentElement('afterend', subtotal);

      const update = () => {
        const quantity = Math.max(1, Number(input.value) || 1);
        subtotal.innerHTML = `<span>Equipment subtotal</span><strong>${money(unitCents * quantity)}</strong>`;
      };
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      input.dataset.lefunlandSubtotalReady = 'true';
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', enhanceQuantity);
  document.addEventListener('shopify:section:load', enhanceQuantity);
  new MutationObserver(enhanceQuantity).observe(document.documentElement, { childList: true, subtree: true });
})();
